import { actions, types } from './requests'
export const GETFROMID_TYPES = {
    ...types('GETFROMID'),
}
export const GETFROMID_ACTIONS = {
    ...actions('GETFROMID'),
}
